import React from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import ResponsiveDrawer from "./ResponsiveDrawer";
import Snackbars from "react-mui-lib/messages-widgets/Snackbars";
import Messages from "react-mui-lib/messages-widgets/Messages";
import { has_permission } from "../utils";
import withStyles from '@material-ui/core/styles/withStyles';

import BeaconGrid from "../beacon/BeaconGrid";
import BeaconForm from "../beacon/BeaconForm";
import GameGrid from "../game/GameGrid";
import GameForm from "../game/GameForm";
import GameTariffSelector from "../game/GameTariffSelector";
import GameEditor from "../game/GameEditor";
import FranchiseGrid from "../franchise/FranchiseGrid";
import FranchiseForm from "../franchise/FranchiseForm";
import PromoForm from "../promo/PromoForm";
import AppUserGrid from "../appuser/AppUserGrid";
import AppUserForm from "../appuser/AppUserForm";
import PromoGrid from "../promo/PromoGrid";
import UserGrid from "../user/UserGrid";
import UserForm from "../user/UserForm";
import SiteContentEditor from "../site-content/SiteContentEditor";
import Mailer from "../mailer/Mailer";
import SupportWidget from "./SupportWidget";
import AccountDeletionDialog from "./AccountDeletionDialog";
import PromoCodeDialog from "./PromoCodeDialog";
import Footer from "./Footer";


class ToolbarContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchor: null,
        };
    }

    render() {
        return <>
            <IconButton color="inherit"
                        ref={this.anchorEl}
                        onClick={e => this.setState({anchor: e.currentTarget})}>
                <AccountCircle />
            </IconButton>
            {window.Params !== undefined &&
                <Button color="inherit"
                        onClick={e => this.setState({anchor: e.currentTarget})}>
                    {window.Params.user.name}
                </Button>
            }
            <Menu id="menu-appbar"
                  anchorEl={this.state.anchor}
                  anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                  }}
                  transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                  }}
                  open={Boolean(this.state.anchor)}
                  onClose={() => this.setState({anchor: null})}>
                <MenuItem component="a" href="/auth/logout">
                    Выйти
                </MenuItem>
            </Menu>
        </>;
    }
}


function DrawerItem({label, link, permission, className, style, onClick}) {
    if (permission && !has_permission(permission)) {
        return null;
    }

    return <ListItem button
                     component={Link}
                     to={link}
                     onClick={onClick}
                     className={className}
                     style={style}>
        <ListItemText primary={label} />
    </ListItem>;
}


function DrawerContentRaw({classes, onItemClick, onNicknameOpen, onDeleteOpen, onPromoOpen}) {
    const [settingsOpen, setSettingsOpen] = React.useState(false);
    const [promosOpen, setPromosOpen] = React.useState(false);
    const [beaconsOpen, setBeaconsOpen] = React.useState(false);

    let idx = -1;
    const cls = () => {
        idx += 1;
        return idx % 2 === 0 ? classes.zebraItem : classes.menuItem;
    };

    const openDialog = (callback) => {
        if (onItemClick) onItemClick();
        callback();
    };

    return <List disablePadding>
        <DrawerItem link="/admin/games"
                    label="Игры"
                    className={cls()}
                    onClick={onItemClick} />
        <DrawerItem link="/admin/game"
                    label="Новая игра"
                    className={cls()}
                    onClick={onItemClick} />
        <Divider />
        <ListItem button onClick={() => setSettingsOpen(!settingsOpen)} className={cls()} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <ListItemText primary="Настройки" />
            {settingsOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
        </ListItem>
        <Collapse in={settingsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                <ListItem button onClick={() => openDialog(onNicknameOpen)} className={cls()} style={{ paddingLeft: 32 }}>
                    <ListItemText primary="Изменить никнейм" />
                </ListItem>
                <ListItem button onClick={() => openDialog(onDeleteOpen)} className={cls()} style={{ paddingLeft: 32 }}>
                    <ListItemText primary="Удалить аккаунт" />
                </ListItem>
            </List>
        </Collapse>
        <ListItem button onClick={() => openDialog(onPromoOpen)} className={cls()}>
            <ListItemText primary="Промокод" />
        </ListItem>
        <Divider />
        { has_permission('admin-panel/promo-access') &&
            <>
                <ListItem button onClick={() => setPromosOpen(!promosOpen)} className={cls()} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ListItemText primary="Акции" />
                    {promosOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
                </ListItem>
                <Collapse in={promosOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <DrawerItem link="/admin/promos"
                                    label="Список"
                                    permission="admin-panel/promo-access"
                                    className={cls()}
                                    style={{ paddingLeft: 32 }}
                                    onClick={onItemClick} />
                        <DrawerItem link="/admin/promo"
                                    label="Добавить"
                                    permission="admin-panel/promo-access"
                                    className={cls()}
                                    style={{ paddingLeft: 32 }}
                                    onClick={onItemClick} />
                    </List>
                </Collapse>
            </>
        }
        { has_permission('admin-panel/promo-access') &&
            <Divider />
        }
        <DrawerItem link="/admin/appusers"
                    label="Игроки"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        { has_permission('admin-panel/superaccess') &&
            <Divider />
        }
        <DrawerItem link="/admin/users"
                    label="Пользователи админки"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        <DrawerItem link="/admin/user"
                    label="Новый пользователь"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        { has_permission('admin-panel/superaccess') &&
            <Divider />
        }
        <DrawerItem link="/admin/franchises"
                    label="Авторы"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        { has_permission('admin-panel/superaccess') &&
            <Divider />
        }
        { has_permission('admin-panel/superaccess') &&
            <>
                <ListItem button onClick={() => setBeaconsOpen(!beaconsOpen)} className={cls()} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ListItemText primary="Маяки" />
                    {beaconsOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
                </ListItem>
                <Collapse in={beaconsOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <DrawerItem link="/admin/beacons"
                                    label="Список"
                                    permission="admin-panel/superaccess"
                                    className={cls()}
                                    style={{ paddingLeft: 32 }}
                                    onClick={onItemClick} />
                        <DrawerItem link="/admin/beacon"
                                    label="Добавить маяк"
                                    permission="admin-panel/superaccess"
                                    className={cls()}
                                    style={{ paddingLeft: 32 }}
                                    onClick={onItemClick} />
                    </List>
                </Collapse>
            </>
        }
        { has_permission('admin-panel/superaccess') &&
            <Divider />
        }
        <DrawerItem link="/admin/site-content"
                    label="Тексты сайта"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        <DrawerItem link="/admin/mail"
                    label="Рассылки"
                    permission="admin-panel/superaccess"
                    className={cls()}
                    onClick={onItemClick} />
        { has_permission('admin-panel/superaccess') &&
            <ListItem button
                      component="a"
                      href="https://support.cryptofox.ru/admin"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={cls()}
                      onClick={onItemClick}>
                <ListItemText primary="Админ поддержки" />
            </ListItem>
        }
    </List>;
}

const drawerStyles = theme => ({
    menuItem: {
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
    },
    zebraItem: {
        backgroundColor: '#eeeeee',
        '&:hover': {
            backgroundColor: '#e0e0e0',
        },
    },
});

const DrawerContent = withStyles(drawerStyles)(DrawerContentRaw);


class NewsBanner extends React.Component {
    constructor(props) {
        super(props);
        const html = (window.Params && window.Params.admin_news) || '';
        this.state = { html, collapsed: false };
        this.toggle = this.toggle.bind(this);
        this.onBarClick = this.onBarClick.bind(this);
    }

    toggle() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    onBarClick(e) {
        if (e.target.closest('a')) {
            return;
        }
        this.toggle();
    }

    render() {
        const { html, collapsed } = this.state;
        if (!html.replace(/<[^>]*>/g, '').trim()) {
            return null;
        }

        const contentStyle = collapsed ? {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxHeight: '1.6em',
        } : {};

        return (
            <div onClick={this.onBarClick}
                 style={{
                display: 'flex',
                alignItems: 'flex-start',
                background: '#e6f6fd',
                borderBottom: '1px solid #b9e4f7',
                borderLeft: '4px solid #0BADEC',
                padding: '6px 8px 6px 24px',
                color: '#333',
                fontSize: 14,
                lineHeight: 1.6,
                cursor: 'pointer',
                userSelect: 'none',
            }}>
                <div className={'admin-news' + (collapsed ? ' admin-news-collapsed' : '')}
                     style={{ flexGrow: 1, minWidth: 0, paddingTop: 4, ...contentStyle }}
                     dangerouslySetInnerHTML={{ __html: html }} />
                <IconButton size="small"
                            onClick={e => { e.stopPropagation(); this.toggle(); }}
                            title={collapsed ? 'Развернуть' : 'Свернуть'}
                            style={{ flexShrink: 0, marginLeft: 8 }}>
                    <Icon>{collapsed ? 'expand_more' : 'expand_less'}</Icon>
                </IconButton>
            </div>
        );
    }
}


function BlockedBanner() {
    const blocked = window.Params && window.Params.franchise && window.Params.franchise.is_blocked;
    if (!blocked) {
        return null;
    }

    return (
        <AppBar position="static" style={{ backgroundColor: '#b71c1c' }}>
            <Toolbar>
                <Typography variant="body1" style={{ flexGrow: 1 }}>
                    Аккаунт заблокирован
                </Typography>
            </Toolbar>
        </AppBar>
    );
}


function BusinessBanner() {
    const franchise = (window.Params && window.Params.franchise) || {};
    const expiresAt = franchise.business_expires_at;
    if (!expiresAt) {
        return null;
    }

    const [busy, setBusy] = React.useState(false);
    const expires = new Date(expiresAt);
    const now = new Date();
    const daysLeft = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));
    const expired = daysLeft <= 0;

    const handleRenew = () => {
        setBusy(true);
        fetch('/admin/rest/franchise/pay-subscription', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': (window.Params && window.Params.csrf_token) || ''
            }
        })
            .then(r => r.json())
            .then(json => {
                setBusy(false);
                if (json.payment_url) {
                    window.open(json.payment_url, '_blank');
                }
            })
            .catch(() => setBusy(false));
    };

    const dateStr = expires.toLocaleDateString('ru-RU');
    const message = expired
        ? 'Тариф Агентство истёк. Продлите подписку, чтобы публиковать игры.'
        : `Тариф Агентство активен до ${dateStr} (осталось ${daysLeft} дн.)`;

    return (
        <AppBar position="static" style={{ backgroundColor: expired ? '#b71c1c' : '#2e7d32' }}>
            <Toolbar>
                <Typography variant="body1" style={{ flexGrow: 1 }}>
                    {message}
                </Typography>
                <Button color="inherit" onClick={handleRenew} disabled={busy}>
                    Продлить
                </Button>
            </Toolbar>
        </AppBar>
    );
}


function DeletionBanner() {
    const initialDeletion = (window.Params && window.Params.user && window.Params.user.deletion)
        || { pending: false };
    const [deletion] = React.useState(initialDeletion);
    const [busy, setBusy] = React.useState(false);

    if (!deletion.pending) {
        return null;
    }

    const handleCancel = () => {
        setBusy(true);
        fetch('/franchise/auth/delete-cancel', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': (window.Params && window.Params.csrf_token) || '',
            },
            body: JSON.stringify({}),
        })
            .then(() => window.location.reload())
            .catch(() => setBusy(false));
    };

    return (
        <AppBar position="static" color="secondary">
            <Toolbar>
                <Typography variant="body1" style={{ flexGrow: 1 }}>
                    Аккаунт будет удалён через {deletion.days_left} дней
                </Typography>
                <Button color="inherit" onClick={handleCancel} disabled={busy}>
                    Отменить удаление
                </Button>
            </Toolbar>
        </AppBar>
    );
}


const ACRoute = ({ component: Component, permission = 'admin-panel/superaccess', ...rest }) =>
  <Route {...rest}
         render={props =>
            has_permission(permission) ?
                <Component {...props} /> :
                <Redirect to={{
                    pathname: '/admin',
                    state: { from: props.location }
                }}/>
         }/>;


class App extends React.Component {
    constructor(props) {
        super(props);

        this.drawer = React.createRef();
        this.state = {
            nicknameOpen: false,
            deleteOpen: false,
            promoOpen: false,
        };

        this.openNicknameDialog = this.openNicknameDialog.bind(this);
        this.closeNicknameDialog = this.closeNicknameDialog.bind(this);
        this.openDeleteDialog = this.openDeleteDialog.bind(this);
        this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
        this.openPromoDialog = this.openPromoDialog.bind(this);
        this.closePromoDialog = this.closePromoDialog.bind(this);
    }

    openNicknameDialog() {
        this.drawer.current.close();
        this.setState({ nicknameOpen: true });
    }

    closeNicknameDialog() {
        this.setState({ nicknameOpen: false });
    }

    openDeleteDialog() {
        this.drawer.current.close();
        this.setState({ deleteOpen: true });
    }

    openPromoDialog() {
        this.drawer.current.close();
        this.setState({ promoOpen: true });
    }

    closePromoDialog() {
        this.setState({ promoOpen: false });
    }

    closeDeleteDialog() {
        this.setState({ deleteOpen: false });
    }

    render() {
        const c = this;
        const { title } = c.props;
        const { nicknameOpen, deleteOpen, promoOpen } = c.state;

        return <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <ResponsiveDrawer title={title}
                              drawerContent={
                                  <DrawerContent onItemClick={c.onDraweritemSelected.bind(c)}
                                                 onNicknameOpen={c.openNicknameDialog}
                                                 onDeleteOpen={c.openDeleteDialog}
                                                 onPromoOpen={c.openPromoDialog} />
                              }
                              ToolbarContent={ToolbarContent}
                              innerRef={c.drawer}>
                <NewsBanner />
                <BlockedBanner />
                <BusinessBanner />
                <DeletionBanner />
                <Snackbars />
                <Messages />
                <AccountDeletionDialog
                    mode="nickname"
                    open={nicknameOpen}
                    onClose={c.closeNicknameDialog}
                />
                <AccountDeletionDialog
                    mode="delete"
                    open={deleteOpen}
                    onClose={c.closeDeleteDialog}
                    onCancel={() => window.location.reload()}
                />
                <PromoCodeDialog
                    open={promoOpen}
                    onClose={c.closePromoDialog}
                />
                <SupportWidget />
                <div style={{ flex: '1 0 auto' }}>
                    <Switch>
                        <Redirect exact from='/' to='/admin/games'/>
                        <Redirect exact from='/admin/' to='/admin/games'/>
                        <Route         path='/admin/games' component={GameGrid}/>
                        <Route   exact path='/admin/game' component={GameTariffSelector}/>
                        <Route   exact path='/admin/game/create' component={GameForm}/>
                        <Route         path='/admin/game/:id' component={GameEditor}/>
                        <Route         path='/admin/beacons' component={BeaconGrid}/>
                        <ACRoute exact path='/admin/beacon' component={BeaconForm}/>
                        <Route         path='/admin/beacon/:id' component={BeaconForm}/>
                        <Route         path='/admin/appusers' component={AppUserGrid}/>
                        <Route         path='/admin/appuser/:id' component={AppUserForm}/>
                        <ACRoute       path='/admin/promos' component={PromoGrid} permission='admin-panel/promo-access' />
                        <ACRoute exact path='/admin/promo' component={PromoForm} permission='admin-panel/promo-access' />
                        <ACRoute       path='/admin/promo/:id' component={PromoForm} permission='admin-panel/promo-access' />
                        <ACRoute       path='/admin/users' component={UserGrid} />
                        <ACRoute exact path='/admin/user' component={UserForm}/>
                        <ACRoute       path='/admin/user/:id' component={UserForm}/>
                        <ACRoute       path='/admin/franchises' component={FranchiseGrid}/>
                        <ACRoute       path='/admin/franchise/:id' component={FranchiseForm}/>
                        <ACRoute       path='/admin/site-content' component={SiteContentEditor}/>
                        <ACRoute       path='/admin/mail' component={Mailer} permission='admin-panel/superaccess'/>
                    </Switch>
                </div>
            </ResponsiveDrawer>
            <Footer />
        </div>;
    }

    onDraweritemSelected() {
        const c = this;

        c.drawer.current.close();
    }

    componentDidMount() {
        const loading = document.getElementById('loading');
        if (loading) {
            loading.parentNode.removeChild(loading);
        }
    }
}

export default App;
